import styled from "styled-components";

export const StyledButton = styled.a`
    text-decoration: none !important;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  StyledButtonHeader = styled.a`
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    @media only screen and (min-width: 600px) {
      display:none;
    }
  `,
  Text = styled.h1`
    text-align: center;
    box-shadow: 0px 15px 40px rgba(82, 67, 170, 0.2);
    color: #ffffff;
    text-decoration: underline;
    border-radius: 25px;
    white-space: nowrap;
    font-size: 15px;
    padding: 0.75rem 1.5rem 0.5rem 1.5rem;
    background: #2D388F;
    transition: background-color 0.4s;
    cursor: pointer;
    &:hover {
      background-color: #00aae4;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.25vw;
      padding: 1vw 2vw 0.75vw 2vw;
      border-radius: 2.5vw;
    } 
  `,
  TextRule = styled.h1`
    text-align: center;
    box-shadow: 0px 15px 40px rgba(82, 67, 170, 0.2);
    color: #ffffff;
    border-radius: 25px;
    white-space: nowrap;
    font-size: 15px;
    padding: 0.75rem 1.5rem 0.5rem 1.5rem;
    background: #2D388F;
    transition: background-color 0.4s;
    cursor: pointer;
    &:hover {
      background-color: #00aae4;
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.25vw;
      padding: 1vw 2vw 0.75vw 2vw;
      border-radius: 2.5vw;
    } 
  `,
  TextBtnHeader = styled.h1`
    text-align: center;
    box-shadow: 0px 15px 40px rgba(82, 67, 170, 0.2);
    color: #ffffff;
    border-radius: 25px;
    white-space: nowrap;
    font-size: 15px;
    padding: 0.75rem 1.5rem 0.5rem 1.5rem;
    background: #083f88;
    transition: background-color 0.4s;
    cursor: pointer;
    &:hover {
      background-color: #00aae4;
    }
    @media only screen and (min-width: 320px) {
      font-size: 11px;
      padding: 0.75rem 1rem 0.5rem 1rem;
      margin-right: 0.5rem
    }
    @media only screen and (min-width: 375px)  and (max-width: 400px){
      font-size: 13px;
      margin-right:0.5rem;  
    }
    @media only screen and (min-width: 401px)  and (max-width: 450px){
      font-size: 14px;
      margin-right:1rem;  
    }
    @media only screen and (min-width: 451px)  and (max-width: 580px){
      font-size: 15px;
      margin-right:1rem;  
    }
    @media only screen and (min-width: 576px)  and (max-width: 599.7px){
     font-size: 16px;
    margin-right:2rem;  
    }
    @media only screen and (min-width: 1000px) {
      font-size: 1.25vw;
      padding: 1vw 2vw 0.75vw 2vw;
      border-radius: 2.5vw;
    } 
    `;
